import styled from 'styled-components';

const LARGE_MOBILE = `34.375rem`;

export const PhoneMockUpImg = styled.img`
  width: 100%;
  max-width: 18.75rem;
  height: auto;
  display: block;
  padding-right: 2rem;

  @media only screen and (max-width: ${LARGE_MOBILE}) {
    width: 17.8rem;
    margin: 0 auto;
    width: 100%;
    padding-right: 0;
  }
`;

export const SignUpFormWrapper = styled.div`
  margin-top: 0rem;
  z-index: 1;
  position: relative;
  width: 55%;

  @media only screen and (max-width: ${LARGE_MOBILE}) {
    margin-top: -7.5rem;
    width: 100%;
  }
`;

export const MockUpTitleDesktop = styled.h2`
  display: block;
  text-align: center;
  margin-bottom: 2rem;
  font-size: 1.25rem;

  @media only screen and (max-width: 46.875rem) {
    display: none;
  }
`;

export const MockUpFormWrapper = styled.div`
  display: flex;
  width: 95%;
  margin: 4rem auto 2rem auto;
  max-width: 62.5rem;
  justify-content: center;

  @media only screen and (max-width: 46.875rem) {
    margin-top: 1rem;
  }

  @media only screen and (max-width: ${LARGE_MOBILE}) {
    display: block;
    width: 100%;
  }

  @media only screen and (max-width: 36rem) {
    margin-top: 2rem;
  }
`;

